import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { AnimateHeight, Drawer } from '@root/shared/ui-kit'

import { ExportWallet } from '../common/export-wallet'

import type { WalletModel } from '@root/entities/wallet/atoms'
import type { DrawerProps } from '@root/shared/ui-kit'

type WalletExportDrawerProps = Pick<DrawerProps, 'onOpenChange' | 'open'> & {
  wallet: WalletModel
}

export const WalletExportDrawer: React.FC<WalletExportDrawerProps> = ({
  open,
  onOpenChange,
  wallet,
}) => {
  const { t } = useTranslation()

  return (
    <Root
      open={open}
      onOpenChange={onOpenChange}
      title={t('wallet.export_wallet')}
    >
      <Body>
        <AnimateHeight>
          <ExportWallet
            wallet={wallet}
            onClose={() => onOpenChange?.(false)}
            device="mobile"
          />
        </AnimateHeight>
      </Body>
    </Root>
  )
}

const Body = styled.div`
  padding-inline: 12px;
  padding-bottom: calc(var(--safe-area-inset-bottom) + 12px);
`

const Root = styled(Drawer)``
